import AlgoritmixModel from "../../model/multilleure/AlgoritmixModel";

const apiUrl = process.env.REACT_APP_API_URL;
export const PutAlgoritmix = async ( dades : AlgoritmixModel[], page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/algoritmix`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(dades)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
